import React from 'react';
import VigaCalculator from './components/VigaCalculator';

const App = () => {
  return (
    <div className="min-h-screen bg-gray-100 py-10">
      <VigaCalculator />
    </div>
  );
};

export default App;


// DONE